module.exports = __webpack_public_path__ + "static/media/rosengarten.5d83e8db.png";